import { MenuItem, Popover, styled } from "@mui/material";

// Styled components for Popover and MenuItem
export const StyledPopover = styled(Popover)({
  "& .MuiPaper-root": {
    width: "fit-content", // Ajusta el ancho del menú
    maxHeight: 120, // Ajusta la altura máxima del menú si hay muchas opciones
    overflowY: "auto", // Habilita el desplazamiento vertical si el menú es más alto que el máximo
  },
});

export const PopoverItem = styled(MenuItem)({
  height: 40,
  border: "1px solid #f0e9e9",
});
